/* product-gallery.js — <onbond-product-gallery> + lightbox */

class OnbondProductGallery extends HTMLElement {
  connectedCallback() {
    this._main    = this.querySelector('[data-main]');
    this._thumbs  = this.querySelectorAll('[data-thumb]');
    this._images  = [];

    this._thumbs.forEach((thumb, i) => {
      this._images.push({
        src:    thumb.dataset.fullSrc || thumb.querySelector('img')?.src,
        srcset: thumb.dataset.srcset  || '',
        alt:    thumb.dataset.alt     || ''
      });
      thumb.addEventListener('click', () => this._setActive(i));
    });

    if (this._main) {
      this._main.addEventListener('mousemove', (e) => this._handleZoom(e));
      this._main.addEventListener('mouseleave', () => this._resetZoom());
      this._main.addEventListener('click', () => {
        const idx = this._activeIndex || 0;
        document.dispatchEvent(new CustomEvent('onbond:lightbox-open', { detail: { index: idx, gallery: this._images } }));
      });
    }

    this._activeIndex = 0;
    if (this._thumbs.length) this._thumbs[0].classList.add('is-active');
  }

  _setActive(index) {
    this._activeIndex = index;
    const img = this._images[index];
    if (!img || !this._main) return;

    const mainImg = this._main.querySelector('img');
    if (mainImg) {
      mainImg.src = img.src;
      if (img.srcset) mainImg.srcset = img.srcset;
      if (img.alt) mainImg.alt = img.alt;
    }

    this._thumbs.forEach((t, i) => {
      t.classList.toggle('is-active', i === index);
    });
  }

  _handleZoom(e) {
    const img = this._main.querySelector('img');
    if (!img) return;
    const rect = this._main.getBoundingClientRect();
    const x = ((e.clientX - rect.left) / rect.width) * 100;
    const y = ((e.clientY - rect.top) / rect.height) * 100;
    img.style.transformOrigin = `${x}% ${y}%`;
    img.style.transform = 'scale(1.6)';
  }

  _resetZoom() {
    const img = this._main?.querySelector('img');
    if (img) {
      img.style.transition = 'transform .3s linear';
      img.style.transform = 'scale(1)';
      setTimeout(() => { if (img) img.style.transition = ''; }, 350);
    }
  }
}

/* ── Lightbox ─────────────────────────────────────────────────────────── */
class OnbondLightbox extends HTMLElement {
  connectedCallback() {
    this._img    = this.querySelector('[data-lightbox-img]');
    this._close  = this.querySelector('[data-lightbox-close]');
    this._prev   = this.querySelector('[data-lightbox-prev]');
    this._next   = this.querySelector('[data-lightbox-next]');
    this._images = [];
    this._index  = 0;

    if (this._close) this._close.addEventListener('click', () => this.close());
    if (this._prev)  this._prev.addEventListener('click', () => this._navigate(-1));
    if (this._next)  this._next.addEventListener('click', () => this._navigate(1));

    this.addEventListener('click', (e) => {
      if (e.target === this) this.close();
    });

    document.addEventListener('keydown', (e) => {
      if (!this.classList.contains('is-open')) return;
      if (e.key === 'Escape') this.close();
      if (e.key === 'ArrowLeft') this._navigate(-1);
      if (e.key === 'ArrowRight') this._navigate(1);
    });

    document.addEventListener('onbond:lightbox-open', (e) => {
      const { index, gallery } = e.detail;
      this._images = gallery || [];
      this._index = index || 0;
      this.open();
    });
  }

  open() {
    this.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    this._showCurrent();
  }

  close() {
    this.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  _navigate(dir) {
    if (!this._images.length) return;
    this._index = (this._index + dir + this._images.length) % this._images.length;
    this._showCurrent();
  }

  _showCurrent() {
    const img = this._images[this._index];
    if (!img || !this._img) return;
    this._img.src = img.src;
    this._img.alt = img.alt || '';
  }
}

if (!customElements.get('onbond-product-gallery')) {
  customElements.define('onbond-product-gallery', OnbondProductGallery);
}
if (!customElements.get('onbond-lightbox')) {
  customElements.define('onbond-lightbox', OnbondLightbox);
}
